export class MtResourceType {
  Name: string;
  Kind: string;
  DefaultUnit: string;
  Resources: MtResource[];
  ResourceEventTypes: MtResourceEventType[];

  constructor(data: any) {
    Object.assign(this, data);
    this.Resources = new Array<MtResource>();
    this.ResourceEventTypes = new Array<MtResourceEventType>();

    if (Array.isArray(data.Resources)) {
      for (const res of data.Resources) {
        this.Resources.push(new MtResource(res));
      }
    }
    if (Array.isArray(data.ResourceEventTypes)) {
      for (const res of data.ResourceEventTypes) {
        this.ResourceEventTypes.push(new MtResourceEventType(res));
      }
    }
  }
}

export class MtResource {
  Id: string;
  Name: string;
  Login: string;
  DefaultUnit: string;
  ResourceEvents: MtResourceEvent[];
  constructor(data: any) {
    Object.assign(this, data);
    this.ResourceEvents = new Array<MtResourceEvent>();
    if (Array.isArray(data.ResourceEvents)) {
      for (const event of data.ResourceEvents) {
        this.ResourceEvents.push(new MtResourceEvent(event));
      }
    }
  }
}

export class MtResourceEvent {
  Id: string;
  Index: number;
  Name: string;
  Code: string;
  IdRefResourceEventType: string;
  Date: string;
  EndDate: string;
  Time: string;
  EndTime: string;
  TimespanOff: number;
  Value: number;
  EndValue: number;
  ResultValue: number;
  Unit: string;
  Comment: string;

  constructor(data: any) {
    Object.assign(this, data);
  }
}

export class MtResourceEventType {
  Id: string;
  Kind: string;
  KindName: string;
  Name: string;
  Code: string;
  DefaultUnit: string;
  constructor(data: any) {
    Object.assign(this, data);
  }
}
